function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }


  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    jQuery('[data-media="'+this.currentVariant.id+'"]').trigger('click');
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

 
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('select[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    if (this.currentVariant && this.currentVariant.available) {
      jQuery('.available span').text("In Stock");
    } else {
       jQuery('.available span').text("Out Of Stock");
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    jQuery('.sku div').text(this.currentVariant.sku);
    
    
    
    
    var selected = jQuery(this).val();
    var name = variants_info[this.currentVariant.id]['_name'];
    var _name = name.replace('&amp;', '&');
    var description = variants_info[this.currentVariant.id]['_description'];
    var short_description = variants_info[this.currentVariant.id]['_short_description'];
     
    jQuery('.product-page-title').text(_name);
    jQuery('.prod-description').html(htmlDecode(description));
    jQuery('.short_description').html(htmlDecode(short_description));
    
    jQuery('.__fbt_current_variant ._name').text(_name);
    jQuery('.__fbt_current_variant ._price').text(Shopify.formatMoney(this.currentVariant.price));
    jQuery('.__fbt_current_variant input').data('price', this.currentVariant.price);
    jQuery('.__fbt_current_variant input').val(this.currentVariant.id);
    
    if(!this.currentVariant.available){
      jQuery('.__fbt_current_variant input').prop('disabled', true);
      jQuery('.__fbt_add_to_cart').prop('disabled', true);
      jQuery('.__fbt_add_to_cart span').text('Sold Out');
      jQuery('.__fbt_check').prop('disabled', true);
      jQuery('.__fbt_image').addClass('__ftb_hide');
    } else {
      jQuery('.__fbt_current_variant input').prop('disabled', false);
      jQuery('.__fbt_add_to_cart').prop('disabled', false);
      jQuery('.__fbt_add_to_cart span').html('Add <b></b> to Cart — <span class="__fbt_total"></span>');
      jQuery('.__fbt_check').prop('disabled', false);
      jQuery('.__fbt_check').prop('checked',true);
      jQuery('.__fbt_image').removeClass('__ftb_hide');
    }


    var size = this.currentVariant.option2;
    if(size=='Single Sided'){
      jQuery('.__current_variant span').text(' - Single Sided');
      jQuery('.__current_variant a').attr('href', jQuery('.__current_variant').data('single'));

      jQuery('.__fbt_warranty input').data('price', jQuery('.__fbt_warranty').data('single-price'));
      jQuery('.__fbt_warranty input').val(jQuery('.__fbt_warranty').data('single'));
      jQuery('.__fbt_warranty ._price').text(Shopify.formatMoney(jQuery('.__fbt_warranty').data('single-price')));

      // jQuery('#warranty').val(jQuery('.__fbt_warranty').data('single'));
      // jQuery('#warranty_price').val(jQuery('.__fbt_warranty').data('single-price'));

      
    }
    if(size=='Dual Sided'){
      jQuery('.__current_variant span').text(' - Dual Sided');
      jQuery('.__current_variant a').attr('href', jQuery('.__current_variant').data('dual'));
      
      jQuery('.__fbt_warranty input').data('price', jQuery('.__fbt_warranty').data('dual-price'));
      jQuery('.__fbt_warranty input').val(jQuery('.__fbt_warranty').data('dual'));
      jQuery('.__fbt_warranty ._price').text(Shopify.formatMoney(jQuery('.__fbt_warranty').data('dual-price')));

      // jQuery('#warranty').val(jQuery('.__fbt_warranty').data('dual'));
      // jQuery('#warranty_price').val(jQuery('.__fbt_warranty').data('dual-price'));
    }
    
    
    
    var totalPrice = 0;
    var count = 0;
    jQuery('input:checkbox.__fbt_check').each(function () {
      if (jQuery(this).is(':checked')) {
        totalPrice += parseFloat(jQuery(this).data('price'));
        count++;
        
      } 
    });
    jQuery('.__fbt_total').text(Shopify.formatMoney(totalPrice));
    jQuery('.__fbt_add_to_cart b').text(count);
 
    media_html(this.currentVariant.id);
    jQuery('#product-media-main-image').slick('refresh');
    jQuery('#product-media-thumbnail-image').slick('refresh');
    
   
    
    var color = this.currentVariant.option1;
    if(color!='Standalone Printer'){
      jQuery('.__current_software p span').text(color);
      
    }
    
    //jQuery('.__current_software img').attr('src', 'https://cdn.shopify.com/s/files/1/0644/8037/9134/files/bodno_bronze_software_250x250.jpg');
    jQuery('.__current_software a').attr('href', '/products/bodno-id-card-software?variant=42860706431230');
    if(color=='Silver Edition'){
    	jQuery('.__current_software img').attr('src','https://cdn.shopify.com/s/files/1/0644/8037/9134/products/bodno-id-card-software-bodno_250x250.jpg?v=1721655326');
        jQuery('.__current_software a').attr('href', '/products/bodno-id-card-software?variant=42860706398462');
    }
    if(color=='Gold Edition'){
    	jQuery('.__current_software img').attr('src', 'https://cdn.shopify.com/s/files/1/0644/8037/9134/products/bodno-id-card-software-bodno_250x250.jpg?v=1721655326');
      jQuery('.__current_software a').attr('href', '/products/bodno-id-card-software?variant=42860706365694');
    }
    if(color=='Platinum Edition'){
    	jQuery('.__current_software img').attr('src', 'https://cdn.shopify.com/s/files/1/0644/8037/9134/products/bodno-id-card-software-bodno_250x250.jpg?v=1721655326');
      jQuery('.__current_software a').attr('href', '/products/bodno-id-card-software?variant=42860706332926');
    }
    if(color=='Diamond Edition'){
    	jQuery('.__current_software img').attr('src', 'https://cdn.shopify.com/s/files/1/0644/8037/9134/products/bodno-id-card-software-bodno_250x250.jpg?v=1721655326');
      jQuery('.__current_software a').attr('href', '/products/bodno-id-card-software?variant=42860706463998');
    }
    
    if(color=='Standalone Printer'){
      jQuery('.what-in-box li').hide();
      jQuery('.what-in-box li.__printer').show();
    } else {
      jQuery('.what-in-box li').show();
    }
    
    jQuery('.product-info-price span').text(Shopify.formatMoney(this.currentVariant.price));
    jQuery('.cart-with-price b').text(Shopify.formatMoney(this.currentVariant.price));
    jQuery('.msrp_update span').text(Shopify.formatMoney(this.currentVariant.compare_at_price));
    if(this.currentVariant.price < this.currentVariant.compare_at_price){
      jQuery('.saving_update span').text(Shopify.formatMoney(this.currentVariant.compare_at_price - this.currentVariant.price));
      jQuery('#custom-price-box').show();
    } else {
      jQuery('#custom-price-box').hide();
    
    }

    
    
    
    
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
   
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('ul'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
  
function media_html(variant) {
  
  var _image = jQuery('#product-media-main-image');
  var _images = jQuery('#product-media-thumbnail-image');
  
  var _image_1 = variants_info[variant]['_image_1'];
  var _image_2 = variants_info[variant]['_image_2'];
  var _image_3 = variants_info[variant]['_image_3'];
  var _image_4 = variants_info[variant]['_image_4'];
  var _image_5 = variants_info[variant]['_image_5'];
  var _image_6 = variants_info[variant]['_image_6'];
  var _image_7 = variants_info[variant]['_image_7'];
  var _image_8 = variants_info[variant]['_image_8'];
  var _image_9 = variants_info[variant]['_image_9'];
  var _image_10 = variants_info[variant]['_image_10'];
  if(_image_1){
    _image.html('');
    _images.html('');
    _image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_1.replace('500x500', '750x750')+'"><img src="'+_image_1.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div></div>');
    _images.append('<div class="item _thumbnail "><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_1.replace('500x500', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  
  if(_image_2){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_2.replace('500x500', '750x750')+'"><img src="'+_image_2.replace('500x500', '750x750')+'" class="img-fluid  __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_2.replace('500x500', '150x150')+'" loading="lazy" width="150" height="150" /></div>');
  }
  if(_image_3){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_3.replace('500x500', '750x750')+'"><img src="'+_image_3.replace('500x500', '750x750')+'" class="img-fluid  __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_3.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_4){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_4.replace('500x500', '750x750')+'"><img src="'+_image_4.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_4.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_5){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_5.replace('500x500', '750x750')+'"><img src="'+_image_5.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_5.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_6){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_6.replace('500x500', '750x750')+'"><img src="'+_image_6.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_6.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_7){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_7.replace('500x500', '750x750')+'"><img src="'+_image_7.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_7.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_8){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_8.replace('500x500', '750x750')+'"><img src="'+_image_8.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_8.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_9){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_9.replace('500x500', '750x750')+'"><img src="'+_image_9.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img class="img-fluid box-inner" src="'+_image_9.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
  if(_image_10){
  	_image.append('<div class="main-product-image"><div class="g-box"><div class="g-box-inner"><a data-lightbox="product-media" href="'+_image_10.replace('500x500', '750x750')+'"><img src="'+_image_10.replace('500x500', '750x750')+'" class="img-fluid __featured_image" width="750" height="750" /></a></div></div></div>');
    _images.append('<div class="item _thumbnail"><div class="g-box"><div class="g-box-inner"><img src="'+_image_10.replace('750x750', '150x150')+'" loading="lazy" width="150" height="150" /></div></div></div>');
  }
        
 
}


function sortMap(map) {
  try {
    map.forEach(function(valueList, key, map) {
      map.get(key).sort();
    });
  } catch(err){
  }
}

function updateList(option, updatedList) {
  try {
    var selectedValue = $(option).children("option:selected").val();
    var index = -1;

    // remove previous list
    $(option).find('option').remove();

    //update list with new values
    for (var i=0; i<updatedList.length; i++) {
      $(option).append($('<option>', { 
        value: updatedList[i],
        text : updatedList[i] 
      }));

      if (updatedList[i] == selectedValue) {
        index = i;
      }
    }
    //update previous selected value    
    if (index != -1) {
      $(option).val(updatedList[index]).change(); 
    } else if (updatedList[0]){
      $(option).val(updatedList[0]).change();
    }
  } catch(err){
  }
}

function updateListByMap(options, map) {
  try {
    var selectedValue1 = $(options[0]).children("option:selected").val();
    map.forEach(function(valueList, key, map) {
      if (key == selectedValue1) {
        updateList(options[1], valueList);
      }
    });
    //remove option-2 values on empty map
    if (map.size == 0) {
      $(options[1]).find('option').remove();
    }
  } catch(err){
  }
}

function updateListByMap1(options, map1) {
  try {
    var selectedValue1 = $(options[0]).children("option:selected").val();
    var selectedValue2 = $(options[1]).children("option:selected").val();
    var variant = selectedValue1+" / "+selectedValue2;
    map1.forEach(function(valueList, key, map) {
      if (key == variant) {
        updateList(options[2], valueList);
      }
    });
    //remove option-3 values on empty map
    if (map1.size == 0) {
      $(options[2]).find('option').remove();
    }
  } catch(err) {
  }
}

function removeImages(colorSelector) {
  try{
    var colorOptions = $(colorSelector).find('option');
    var imageOptions = $('.product-single__thumbnails-product-template').find('li');
    if (imageOptions.length != colorOptions.length) {
      // hide previous images
      $(imageOptions).hide();
      
      //show availabe variants images
      for (var l=0; l<colorOptions.length; l++) {
        var colorName = $(colorOptions[l]).val();
        $("#"+colorName).show();
      }
      
    }
  } catch(err){
    console.log(err);
  }
}